module.exports = __webpack_public_path__ + "img/157-aland islands.5bafcc41.svg";